import React, { useState } from 'react';
import './ForgotPassword.css';

const ForgotPassword = ({ onClose }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [esError, setEsError] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const handleEnviar = async () => {
    if (!email.trim()) {
      setEsError(true);
      setMensaje('Por favor ingresa tu email.');
      return;
    }

    setIsLoading(true);
    setMensaje('');

    try {
      const response = await fetch(
        `${process.env.REACT_APP_AUTH_CREADOR_URL}/forgot_password.php`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email.trim() })
        }
      );
      const data = await response.json();
      setEsError(!data.success);
      setMensaje(data.message);
      if (data.success) setEnviado(true);
    } catch (e) {
      setEsError(true);
      setMensaje('Error de conexi�n. Intenta de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fp-overlay">
      <div className="fp-modal">
        <button className="fp-cerrar" onClick={onClose}>?</button>

        <div className="fp-icono"><i className="fas fa-key"></i></div>
        <h2 className="fp-titulo">
          {enviado ? '\u00A1Revisa tu email!' : 'Recuperar contrase\u00F1a'}
        </h2>

        {!enviado ? (
          <>
            <p className="fp-subtexto">
              Ingresa tu email registrado y te enviaremos un enlace para
              restablecer tu contrase&ntilde;a.
            </p>
            <input
              type="email"
              className="fp-input"
              placeholder="Tu email registrado"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
            />
            {mensaje && (
              <p className={esError ? 'fp-error' : 'fp-success'}>{mensaje}</p>
            )}
            <button
              className="fp-btn-enviar"
              onClick={handleEnviar}
              disabled={isLoading}
            >
              {isLoading ? 'Enviando...' : 'Enviar enlace'}
            </button>
          </>
        ) : (
<>
            <p className="fp-subtexto">
              {'Si tu email est\u00E1 registrado, recibir\u00E1s un enlace en los pr\u00F3ximos minutos. Revisa tambi\u00E9n tu carpeta de spam.'}
            </p>
            <button className="fp-btn-enviar" onClick={onClose}>
              Cerrar
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;